export default "__VITE_ASSET__Cjn7BFod__"